function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1968(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.61,
    height: 10.81,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8016666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 5.405,
    fontFamily: "Arial"
  }, "\n        Glades\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.81,
    width: 22.61,
    height: 14.63,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6255555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 18.125,
    fontFamily: "Arial"
  }, "\n        Lafayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 25.44,
    width: 22.61,
    height: 14.96,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6622222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 32.92,
    fontFamily: "Arial"
  }, "\n        Gilchrist\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.4,
    width: 22.61,
    height: 16.45,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.29
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 48.625,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.85,
    width: 22.61,
    height: 17.02,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 65.36,
    fontFamily: "Arial"
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.87,
    width: 22.61,
    height: 17.61,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5157142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 82.67500000000001,
    fontFamily: "Arial"
  }, "\n        Flagler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.48,
    width: 22.61,
    height: 20.68,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.136
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 101.82000000000001,
    fontFamily: "Arial"
  }, "\n        Dixie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 112.17,
    width: 22.61,
    height: 23.33,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 123.83500000000001,
    fontFamily: "Arial"
  }, "\n        Wakulla\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 135.5,
    width: 22.61,
    height: 27.05,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 149.025,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.55,
    width: 22.61,
    height: 27.17,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.522
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 176.13500000000002,
    fontFamily: "Arial"
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 189.72,
    width: 22.61,
    height: 29.8,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.261
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 204.62,
    fontFamily: "Arial"
  }, "\n        Okeechobee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.52,
    width: 22.61,
    height: 30.63,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.5122222222222224
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 234.835,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250.15,
    width: 22.61,
    height: 31,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 265.65,
    fontFamily: "Arial"
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 281.15,
    width: 22.61,
    height: 31.08,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 296.69,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 312.22,
    width: 22.61,
    height: 32.98,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.768333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 328.71000000000004,
    fontFamily: "Arial"
  }, "\n        Hendry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 345.2,
    width: 22.61,
    height: 37.64,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 364.02,
    fontFamily: "Arial"
  }, "\n        Gulf\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 382.84,
    width: 22.61,
    height: 39.24,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 402.46,
    fontFamily: "Arial"
  }, "\n        Levy\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 422.08,
    width: 22.61,
    height: 40.56,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.768333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 442.36,
    fontFamily: "Arial"
  }, "\n        DeSoto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 462.64,
    width: 22.61,
    height: 44.68,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.768333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 484.97999999999996,
    fontFamily: "Arial"
  }, "\n        Hardee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 507.32,
    width: 22.61,
    height: 46.87,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.82625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 530.755,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 554.18,
    width: 22.61,
    height: 46.91,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.23
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 577.635,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 601.09,
    width: 22.61,
    height: 48.86,
    style: {
      fill: "#007F00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.261
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 625.52,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 649.94,
    width: 22.61,
    height: 50.06,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.768333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.305,
    y: 674.97,
    fontFamily: "Arial"
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 0,
    width: 28.4,
    height: 39.95,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.733333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 36.81,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.01,
    y: 0,
    width: 30.21,
    height: 39.95,
    style: {
      fill: "#004C00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.035
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 66.115,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.23,
    y: 0,
    width: 33.44,
    height: 39.95,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.95,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Hernando\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.66,
    y: 0,
    width: 33.54,
    height: 39.95,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 131.43,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Suwannee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 148.2,
    y: 0,
    width: 36.63,
    height: 39.95,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 166.515,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.83,
    y: 0,
    width: 40.08,
    height: 39.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.87,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Citrus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.91,
    y: 0,
    width: 40.15,
    height: 39.95,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.98499999999999,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.06,
    y: 0,
    width: 41.2,
    height: 39.95,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.99375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.66,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306.26,
    y: 0,
    width: 50.78,
    height: 39.95,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.65,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Gadsden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.04,
    y: 0,
    width: 51.87,
    height: 39.95,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.9875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 382.975,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.91,
    y: 0,
    width: 53.28,
    height: 39.95,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.55,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Osceola\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 462.19,
    y: 0,
    width: 57.36,
    height: 39.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.87,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 519.55,
    y: 0,
    width: 59.12,
    height: 39.95,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.707142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.1099999999999,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Collier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 578.66,
    y: 0,
    width: 59.52,
    height: 39.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.438888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 608.42,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Highlands\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.19,
    y: 0,
    width: 61.81,
    height: 39.95,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.658333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.095,
    y: 19.975,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 39.95,
    width: 62.36,
    height: 40.62,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.513333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 60.260000000000005,
    fontFamily: "Arial"
  }, "\n        St._Johns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 80.57,
    width: 62.36,
    height: 43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.777777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 102.07,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 123.57,
    width: 62.36,
    height: 44.29,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.327142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 145.715,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 167.86,
    width: 62.36,
    height: 45.67,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.567
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 190.69500000000002,
    fontFamily: "Arial"
  }, "\n        Santa_Rosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 213.53,
    width: 62.36,
    height: 45.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8066666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 236.37,
    fontFamily: "Arial"
  }, "\n        Indian_River\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 259.21,
    width: 62.36,
    height: 53.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.918333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 285.965,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 312.72,
    width: 62.36,
    height: 60.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.753333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 343.11,
    fontFamily: "Arial"
  }, "\n        St._Lucie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 373.5,
    width: 62.36,
    height: 74.78,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 410.89,
    fontFamily: "Arial"
  }, "\n        Okaloosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 448.29,
    width: 62.36,
    height: 82.13,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.393333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 489.355,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 530.41,
    width: 62.36,
    height: 82.61,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.472
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 571.7149999999999,
    fontFamily: "Arial"
  }, "\n        Pasco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.61,
    y: 613.02,
    width: 62.36,
    height: 86.98,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.795
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.79,
    y: 656.51,
    fontFamily: "Arial"
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.97,
    y: 39.95,
    width: 66.93,
    height: 81.32,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.310000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.435,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Bay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 151.9,
    y: 39.95,
    width: 68.31,
    height: 81.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.0775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.055,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.21,
    y: 39.95,
    width: 78.29,
    height: 81.32,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.184285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 259.355,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Alachua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.51,
    y: 39.95,
    width: 85.64,
    height: 81.32,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.106666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.33,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.15,
    y: 39.95,
    width: 89.8,
    height: 81.32,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.33
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 429.04999999999995,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Leon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.95,
    y: 39.95,
    width: 95.7,
    height: 81.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.617142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.8,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Manatee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.65,
    y: 39.95,
    width: 130.35,
    height: 81.32,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.8249999999999,
    y: 80.61,
    fontFamily: "Arial"
  }, "\n        Sarasota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.97,
    y: 121.27,
    width: 112.69,
    height: 135.89,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.08625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.315,
    y: 189.21499999999997,
    fontFamily: "Arial"
  }, "\n        Escambia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.97,
    y: 257.15,
    width: 112.69,
    height: 139.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.09857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.315,
    y: 326.92999999999995,
    fontFamily: "Arial"
  }, "\n        Volusia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.97,
    y: 396.72,
    width: 112.69,
    height: 149.62,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.315,
    y: 471.53000000000003,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.97,
    y: 546.34,
    width: 112.69,
    height: 153.66,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.09857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 141.315,
    y: 623.1700000000001,
    fontFamily: "Arial"
  }, "\n        Brevard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.65,
    y: 121.27,
    width: 140.55,
    height: 160.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 23.425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.925,
    y: 201.475,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.21,
    y: 121.27,
    width: 163.25,
    height: 160.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.041
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.835,
    y: 201.475,
    fontFamily: "Arial"
  }, "\n        Palm_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.46,
    y: 121.27,
    width: 198.54,
    height: 160.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.3675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.73,
    y: 201.475,
    fontFamily: "Arial"
  }, "\n        Hillsborough\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.65,
    y: 281.68,
    width: 193.66,
    height: 193.11,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.622
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.48,
    y: 378.235,
    fontFamily: "Arial"
  }, "\n        Duval\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.65,
    y: 474.79,
    width: 193.66,
    height: 225.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.665714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.48,
    y: 587.395,
    fontFamily: "Arial"
  }, "\n        Broward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.31,
    y: 281.68,
    width: 308.69,
    height: 153.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.16
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.655,
    y: 358.32,
    fontFamily: "Arial"
  }, "\n        Pinellas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.31,
    y: 434.96,
    width: 308.69,
    height: 265.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 66.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.655,
    y: 567.48,
    fontFamily: "Arial"
  }, "\n        Dade\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1968);
export default __webpack_public_path__ + "static/media/1968.05f1d5bb9e5ceca5fa61e2d009a17b13.svg";
export { ForwardRef as ReactComponent };